import React, {useEffect} from "react";
import FlexView from "react-flexview";
import classes from './Signup.module.scss';
import Footer from "../../../common/ui/Footer/Footer.component";
import SignupForm from "../SignupForm/SignupForm.component";
import {useTranslation} from "react-i18next";
import {trackCurrentPage} from "../../../services/googleAnalytics";

const Signup = () => {

    const t = useTranslation().t

    useEffect(() => {
        trackCurrentPage()
    }, [])
    
    return (
        <FlexView column className='component' vAlignContent='top' hAlignContent='center'>

            <div className={classes.title}>{t('Sign up')}</div>

            <SignupForm signupForm/>

            <Footer/>

        </FlexView>
    );
};

export default Signup;
